import { createContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface SurveyData {
  lang: string;
}

export const LocalTranslationContext = createContext<{
  t: (key: string, fill?: object) => string;
} | null>(null);

export const useLocalTranslation = (surveyData: SurveyData) => {
  const { i18n } = useTranslation('customSurvey');

  const localTranslationProviderValue = useMemo(
    () => ({
      t: (key: string, fill = {}) => {
        const fullKey = 'customSurvey:' + key;
        if (i18n.exists(fullKey, { lng: surveyData.lang })) {
          return i18n.t(fullKey, { lng: surveyData.lang, ...fill });
        }
        return i18n.t(key, { lng: surveyData.lang, ...fill });
      },
    }),
    [surveyData.lang, i18n]
  );

  return localTranslationProviderValue;
};
